import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import menuList from './common/menuList.js'

Vue.use(Router)

export default new Router({
  mode: "history",
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            redirect: '/home',
            children: [
                {
                    path: '/home',
                    name: '首页',
                    meta: {
                        requireAuth: true,
                    },
                    menuIcon: 'menu-icon1',
                    component: resolve => require(['./views/home/index.vue'], resolve)
                },
                ...getRoutes(menuList)
            ]
        },
        {
            path: '/login',
            component: resolve => require(['./views/Login.vue'], resolve)
        },
        {
            path: '/embed',
            component: resolve => require(['./views/embed/EmbedLayout.vue'], resolve),
            children: [
                {
                    path: '',
                    name: 'EmbedEntry',
                    meta: { requireAuth: false },
                    component: resolve => require(['./views/embed/EmbedEntry.vue'], resolve)
                },
                {
                    path: 'cpSettlementSalePurchaseOrder',
                    name: 'embedCpSettlementSalePurchaseOrder',
                    meta: { requireAuth: true, embed: true },
                    component: resolve => require(['./views/cpCentral/salePurchaseOrderDisplay.vue'], resolve)
                }
            ]
        },
        {
            path: '/400',
            component: resolve => require(['./components/common/400.vue'], resolve)
        },
        {
            path: '/404',
            component: resolve => require(['./components/common/404.vue'], resolve)
        },
        {
            path: '/403',
            component: resolve => require(['./components/common/403.vue'], resolve)
        },
        {
            path: '/RMS/H5',
            component: resolve => require(['./views/RMS/H5/index.vue'], resolve)
        },
        {
            path: '/RMS/H5/list',
            component: resolve => require(['./views/RMS/H5/list.vue'], resolve)
        },
        {
            path: '/RMS/H5/orderList',
            component: resolve => require(['./views/RMS/H5/orderList.vue'], resolve)
        },
        {
            path: '/RMS/H5/customerList',
            component: resolve => require(['./views/RMS/H5/customerList.vue'], resolve)
        },
        {
            path: '/RMS/H5/details',
            component: resolve => require(['./views/RMS/H5/details.vue'], resolve)
        },
        {
            path: '/RMS/H5/subsidiaryList',
            component: resolve => require(['./views/RMS/H5/subsidiaryList.vue'], resolve)
        },
        {
            path: '/RMS/H5/subsidiaryEntry',
            component: resolve => require(['./views/RMS/H5/subsidiaryEntry.vue'], resolve)
        },
        {
            path: '/RMS/H5/subsidiaryOrderList',
            component: resolve => require(['./views/RMS/H5/subsidiaryOrderList.vue'], resolve)
        },
        {
            path: '/RMS/H5/subsidiaryFeedback',
            component: resolve => require(['./views/RMS/H5/subsidiaryFeedback.vue'], resolve)
        },
        {
            path: '*',
            component: resolve => require(['./components/common/404.vue'], resolve)
        }
    ]
})
function getRoutes(menuList) {
    const menu = JSON.parse(sessionStorage.getItem("MENULIST"));
    let routes = [];
    if (menu && menu.length) {
        menu.forEach((item, index)=>{
            if(menuList[item.imgPath]){
                item.children.forEach((item1, index1) => {
                    if(menuList[item.imgPath].children[item1.imgPath]){
                        let obj = menuList[item.imgPath].children[item1.imgPath];
                        routes.push({
                            path: obj.path,
                            name: obj.title,
                            component: resolve => require(['@/views/' + obj.resoureUrl + '.vue'], resolve),
                            meta: {
                                requireAuth: true,
                            }
                        })
                    };
                })
            };
        });
    }
    
    
    // let routes = [];
    // for (var i = 0; i < menuList.length; i++) {
    //     if (menuList[i].children) {
    //         for (var j = 0; j < menuList[i].children.length; j++) {
    //             let item = menuList[i].children[j]
    //             if (item) {
    //                 routes.push({
    //                     path: item.path,
    //                     name: item.title,
    //                     component: resolve => require(['@/views/' + item.resoureUrl + '.vue'], resolve),
    //                     meta: {
    //                         requireAuth: true,
    //                     }
    //                 })
    //             }
    //         }
    //     }
    // }
    return routes
}